import React, { CSSProperties, ReactNode, useEffect, useState } from 'react'
import className from 'classnames/bind'

import style from './MyhouseAuthMethod.module.scss'

import IconCloseTooltip from '@Root/ui/images/myhouse/IconCloseTooltip.svg'
import ArrowTooltip from '@Root/ui/images/myhouse/ArrowTooltip.svg'
import { AUTHENTICATION_MAX_COUNT } from '@Root/contants/myhouse'

const cx = className.bind(style)

type Props = {
  wrapClass?: string
  title?: string
  text?: string
  error?: string
  mobileOnly?: boolean
  isMobile?: boolean
  errorCount?: number
  onClick?: (e: React.SyntheticEvent) => void
  tooltipText?: string
}

const MyhouseAuthMethod: React.FC<Props> = ({ wrapClass, title, text, error, errorCount, onClick, isMobile, mobileOnly, tooltipText }: Props) => {
  //변수선언부
  const showErrorMessage = error && errorCount != null && errorCount > 0
  const [errorMessage, setErrorMessage] = useState(error)
  const [showMobileErrorMessage, setShowMobileErrorMessage] = useState(false)
  const [disabled, setDisabled] = useState(false)

  // TODO: 무료 화재보험 진행시 처리
  const insuranceDisabled = false
  const [isTooltip, setIsTooltip] = useState(
    false,
    // Boolean(tooltipText && (localStorage.getItem('myhouse:auth:owner:insurance:close') || 'N') === 'N'),
  )

  //함수정의부
  const handleClick = (e: React.SyntheticEvent) => {
    e.preventDefault()
    if (!disabled && onClick) {
      onClick(e)
    }
  }

  const handleCloseTooltip = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    setIsTooltip(false)
    localStorage.setItem('myhouse:auth:owner:insurance:close', 'Y')
  }

  //useEffect
  useEffect(() => {
    if (errorCount && errorCount >= AUTHENTICATION_MAX_COUNT) {
      setDisabled(true)
      setErrorMessage('더 이상 인증을 할 수 없습니다.')
    }
  }, [errorCount])

  useEffect(() => {
    if (mobileOnly && !isMobile) {
      setShowMobileErrorMessage(true)
    }
  }, [mobileOnly, isMobile])

  return (
    // todo: 실패 2회이상일때 article에 disabled 추가 */
    <a href="#" onClick={handleClick} className={cx('article', disabled && 'disabled', wrapClass)}>
      {text && <span className={cx('text')}>{text}</span>}
      <span className={cx('title')}>{title}</span>
      {showErrorMessage && (
        <span className={cx('error')}>
          {errorMessage}({errorCount}/{AUTHENTICATION_MAX_COUNT})
        </span>
      )}
      {showMobileErrorMessage && <span className={cx('mobile')}>모바일에서만 인증 가능한 방법입니다.</span>}
      {/* TODO: 무료 화재보험 진행시 처리 */}
      {!insuranceDisabled && isTooltip && (
        <span className={cx('layer')} onClick={(e) => e.stopPropagation()}>
          {tooltipText}
          <button type="button" id={'trend_price_close_button'} className={cx('button_close')} onClick={(e) => handleCloseTooltip(e)}>
            <IconCloseTooltip />
            <span className="blind">닫기</span>
          </button>
          <ArrowTooltip />
        </span>
      )}
    </a>
  )
}

export default MyhouseAuthMethod
